import dayjs from 'dayjs';

/** Parse form/API date strings (`YYYY-MM-DD` or ISO) into a local `Date`. */
export function parseFormDate(value: string | null | undefined, fallback?: string): Date | null {
  const source = value || fallback;
  if (!source) return null;

  const isoDate = /^(\d{4})-(\d{2})-(\d{2})/.exec(source);
  if (isoDate) {
    const [, year, month, day] = isoDate;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const date = new Date(source);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Format a `Date` as `YYYY-MM-DD` for form/API storage. */
export function formatFormDate(date: Date | null): string | null {
  if (!date || Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Parse react-hook-form date values into a `Date` for ui-components pickers. */
export function parseDateFormValue(value: unknown, fallback?: string): Date | null {
  if (value == null || value === '') {
    return parseFormDate(fallback);
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value.toDate() : null;
  }

  if (typeof value === 'string') {
    return parseFormDate(value);
  }

  return null;
}
